// Cabin Crew Training - Tüm Ders İçerikleri
// 26 Ünite x 5 Ders = 130 Ders İçeriği

export const LESSON_CONTENTS = {
  // ==================== BÖLÜM 1: TEMEL İNGİLİZCE ====================
  
  // ÜNİTE 1: Alfabe & Sayılar
  '1-1': {
    type: 'flashcard',
    title: 'İngilizce Alfabe',
    cards: [
      { front: 'A', back: 'Ey', audio: 'A harfi' },
      { front: 'B', back: 'Bi', audio: 'B harfi' },
      { front: 'C', back: 'Si', audio: 'C harfi' },
      { front: 'D', back: 'Di', audio: 'D harfi' },
      { front: 'E', back: 'İ', audio: 'E harfi' },
      { front: 'F', back: 'Ef', audio: 'F harfi' },
      { front: 'G', back: 'Ci', audio: 'G harfi' },
      { front: 'H', back: 'Eyç', audio: 'H harfi' },
      { front: 'I', back: 'Ay', audio: 'I harfi' },
      { front: 'J', back: 'Cey', audio: 'J harfi' },
      { front: 'K', back: 'Key', audio: 'K harfi' },
      { front: 'L', back: 'El', audio: 'L harfi' },
      { front: 'M', back: 'Em', audio: 'M harfi' },
      { front: 'N', back: 'En', audio: 'N harfi' },
      { front: 'O', back: 'Ou', audio: 'O harfi' },
      { front: 'P', back: 'Pi', audio: 'P harfi' },
      { front: 'Q', back: 'Kyu', audio: 'Q harfi' },
      { front: 'R', back: 'Ar', audio: 'R harfi' },
      { front: 'S', back: 'Es', audio: 'S harfi' },
      { front: 'T', back: 'Ti', audio: 'T harfi' },
      { front: 'U', back: 'Yu', audio: 'U harfi' },
      { front: 'V', back: 'Vi', audio: 'V harfi' },
      { front: 'W', back: 'Dablyu', audio: 'W harfi' },
      { front: 'X', back: 'Eks', audio: 'X harfi' },
      { front: 'Y', back: 'Vay', audio: 'Y harfi' },
      { front: 'Z', back: 'Zed/Zi', audio: 'Z harfi' },
    ]
  },
  '1-2': {
    type: 'voice',
    title: 'Alfabe Telaffuz',
    phrases: [
      { text: 'A B C D E F G', translation: 'Ey Bi Si Di İ Ef Ci' },
      { text: 'H I J K L M N', translation: 'Eyç Ay Cey Key El Em En' },
      { text: 'O P Q R S T U', translation: 'Ou Pi Kyu Ar Es Ti Yu' },
      { text: 'V W X Y Z', translation: 'Vi Dablyu Eks Vay Zed' },
      { text: 'Can you spell your name?', translation: 'Adınızı heceleyebilir misiniz?' },
      { text: 'My name is spelled...', translation: 'Adım şöyle yazılır...' },
    ]
  },
  '1-3': {
    type: 'flashcard',
    title: 'Sayılar 1-20',
    cards: [
      { front: '1', back: 'One (Van)' },
      { front: '2', back: 'Two (Tu)' },
      { front: '3', back: 'Three (Tıri)' },
      { front: '4', back: 'Four (For)' },
      { front: '5', back: 'Five (Fayv)' },
      { front: '6', back: 'Six (Siks)' },
      { front: '7', back: 'Seven (Sevın)' },
      { front: '8', back: 'Eight (Eyt)' },
      { front: '9', back: 'Nine (Nayn)' },
      { front: '10', back: 'Ten (Ten)' },
      { front: '11', back: 'Eleven (İlevın)' },
      { front: '12', back: 'Twelve (Tvelv)' },
      { front: '13', back: 'Thirteen (Törtin)' },
      { front: '14', back: 'Fourteen (Fortin)' },
      { front: '15', back: 'Fifteen (Fiftin)' },
      { front: '16', back: 'Sixteen (Sikstin)' },
      { front: '17', back: 'Seventeen (Sevıntin)' },
      { front: '18', back: 'Eighteen (Eytin)' },
      { front: '19', back: 'Nineteen (Nayntin)' },
      { front: '20', back: 'Twenty (Tventi)' },
    ]
  },
  '1-4': {
    type: 'flashcard',
    title: 'Sayılar 20-100',
    cards: [
      { front: '20', back: 'Twenty (Tventi)' },
      { front: '30', back: 'Thirty (Törti)' },
      { front: '40', back: 'Forty (Forti)' },
      { front: '50', back: 'Fifty (Fifti)' },
      { front: '60', back: 'Sixty (Siksti)' },
      { front: '70', back: 'Seventy (Sevınti)' },
      { front: '80', back: 'Eighty (Eyti)' },
      { front: '90', back: 'Ninety (Naynti)' },
      { front: '100', back: 'One Hundred (Van Handrıd)' },
      { front: '21', back: 'Twenty-one' },
      { front: '35', back: 'Thirty-five' },
      { front: '47', back: 'Forty-seven' },
      { front: '63', back: 'Sixty-three' },
      { front: '89', back: 'Eighty-nine' },
      { front: '99', back: 'Ninety-nine' },
    ]
  },
  '1-5': {
    type: 'quiz',
    title: 'Pratik Quiz',
    questions: [
      { question: '"Five" hangi sayıdır?', options: ['3', '5', '7', '9'], correct: 1 },
      { question: '"Thirteen" hangi sayıdır?', options: ['13', '30', '3', '33'], correct: 0 },
      { question: '15 İngilizce nasıl yazılır?', options: ['Fifty', 'Five', 'Fifteen', 'Fiveteen'], correct: 2 },
      { question: '"H" harfinin okunuşu nedir?', options: ['Ha', 'Eyç', 'He', 'Aş'], correct: 1 },
      { question: '"W" harfinin okunuşu nedir?', options: ['Ve', 'Vu', 'Dablyu', 'Vav'], correct: 2 },
      { question: '80 İngilizce nasıl söylenir?', options: ['Eight', 'Eighteen', 'Eighty', 'Eigthy'], correct: 2 },
      { question: '"Q" harfinin okunuşu nedir?', options: ['Ku', 'Kyu', 'Ke', 'Ka'], correct: 1 },
      { question: '44 İngilizce nasıl yazılır?', options: ['Fourty-four', 'Forty-four', 'Forteen-four', 'Four-four'], correct: 1 },
    ]
  },

  // ÜNİTE 2: Selamlaşma
  '2-1': {
    type: 'flashcard',
    title: 'Merhaba & Güle güle',
    cards: [
      { front: 'Hello', back: 'Merhaba' },
      { front: 'Hi', back: 'Selam' },
      { front: 'Good morning', back: 'Günaydın' },
      { front: 'Good afternoon', back: 'Tünaydın / İyi öğleden sonralar' },
      { front: 'Good evening', back: 'İyi akşamlar' },
      { front: 'Good night', back: 'İyi geceler' },
      { front: 'Goodbye', back: 'Hoşça kal / Güle güle' },
      { front: 'Bye', back: 'Görüşürüz' },
      { front: 'See you later', back: 'Sonra görüşürüz' },
      { front: 'See you tomorrow', back: 'Yarın görüşürüz' },
      { front: 'Take care', back: 'Kendine iyi bak' },
      { front: 'Have a nice day', back: 'İyi günler' },
    ]
  },
  '2-2': {
    type: 'flashcard',
    title: 'Nasılsınız?',
    cards: [
      { front: 'How are you?', back: 'Nasılsınız?' },
      { front: 'I am fine, thank you.', back: 'İyiyim, teşekkürler.' },
      { front: 'I am good.', back: 'İyiyim.' },
      { front: 'I am great!', back: 'Harikayım!' },
      { front: 'Not bad.', back: 'Fena değil.' },
      { front: 'So so.', back: 'Şöyle böyle.' },
      { front: 'And you?', back: 'Ya siz? / Peki siz?' },
      { front: 'How about you?', back: 'Siz nasılsınız?' },
      { front: 'I am tired.', back: 'Yorgunum.' },
      { front: 'I am happy.', back: 'Mutluyum.' },
      { front: 'I am excited.', back: 'Heyecanlıyım.' },
    ]
  },
  '2-3': {
    type: 'roleplay',
    title: 'Tanışma Diyalogu',
    dialogue: [
      { speaker: 'A', text: 'Hello! My name is Sarah.', translation: 'Merhaba! Benim adım Sarah.' },
      { speaker: 'B', text: 'Hi Sarah! I am John. Nice to meet you.', translation: 'Selam Sarah! Ben John. Tanıştığımıza memnun oldum.' },
      { speaker: 'A', text: 'Nice to meet you too. How are you?', translation: 'Ben de memnun oldum. Nasılsınız?' },
      { speaker: 'B', text: 'I am fine, thank you. And you?', translation: 'İyiyim, teşekkürler. Ya siz?' },
      { speaker: 'A', text: 'I am great, thanks!', translation: 'Harikayım, teşekkürler!' },
      { speaker: 'B', text: 'Where are you from?', translation: 'Nerelisiniz?' },
      { speaker: 'A', text: 'I am from Turkey. And you?', translation: 'Türkiye\'den. Ya siz?' },
      { speaker: 'B', text: 'I am from England. Nice talking to you!', translation: 'İngiltere\'den. Sizinle konuşmak güzeldi!' },
    ]
  },
  '2-4': {
    type: 'voice',
    title: 'Telaffuz Pratiği',
    phrases: [
      { text: 'Hello, how are you?', translation: 'Merhaba, nasılsınız?' },
      { text: 'Good morning, sir.', translation: 'Günaydın, efendim.' },
      { text: 'Good evening, madam.', translation: 'İyi akşamlar, hanımefendi.' },
      { text: 'Nice to meet you.', translation: 'Tanıştığımıza memnun oldum.' },
      { text: 'See you later!', translation: 'Sonra görüşürüz!' },
      { text: 'Have a nice flight!', translation: 'İyi uçuşlar!' },
    ]
  },
  '2-5': {
    type: 'quiz',
    title: 'Selamlaşma Quiz',
    questions: [
      { question: '"Günaydın" İngilizce nasıl denir?', options: ['Good night', 'Good morning', 'Good evening', 'Good afternoon'], correct: 1 },
      { question: '"How are you?" ne demek?', options: ['Neredesin?', 'Kim var?', 'Nasılsın?', 'Ne yapıyorsun?'], correct: 2 },
      { question: '"Nice to meet you" ne demek?', options: ['Görüşürüz', 'Tanıştığıma memnun oldum', 'İyi günler', 'Hoşça kal'], correct: 1 },
      { question: 'Akşam vakti hangi selamlama kullanılır?', options: ['Good morning', 'Good afternoon', 'Good evening', 'Good night'], correct: 2 },
      { question: '"I am fine" ne demek?', options: ['İyiyim', 'Yorgunum', 'Mutluyum', 'Kötüyüm'], correct: 0 },
      { question: '"Goodbye" ne demek?', options: ['Merhaba', 'Günaydın', 'Hoşça kal', 'Nasılsın'], correct: 2 },
    ]
  },

  // ÜNİTE 3: Soru Kalıpları
  '3-1': {
    type: 'flashcard',
    title: 'What / Where / When',
    cards: [
      { front: 'What?', back: 'Ne?' },
      { front: 'What is this?', back: 'Bu nedir?' },
      { front: 'What is your name?', back: 'Adınız ne?' },
      { front: 'What time is it?', back: 'Saat kaç?' },
      { front: 'Where?', back: 'Nerede?' },
      { front: 'Where is the toilet?', back: 'Tuvalet nerede?' },
      { front: 'Where are you from?', back: 'Nerelisiniz?' },
      { front: 'Where is my seat?', back: 'Koltuğum nerede?' },
      { front: 'When?', back: 'Ne zaman?' },
      { front: 'When do we land?', back: 'Ne zaman iniyoruz?' },
      { front: 'When is the meal service?', back: 'Yemek servisi ne zaman?' },
    ]
  },
  '3-2': {
    type: 'flashcard',
    title: 'How / Why / Who',
    cards: [
      { front: 'How?', back: 'Nasıl?' },
      { front: 'How are you?', back: 'Nasılsınız?' },
      { front: 'How much?', back: 'Ne kadar? (fiyat)' },
      { front: 'How many?', back: 'Kaç tane?' },
      { front: 'How long?', back: 'Ne kadar süre?' },
      { front: 'Why?', back: 'Neden?' },
      { front: 'Why not?', back: 'Neden olmasın?' },
      { front: 'Who?', back: 'Kim?' },
      { front: 'Who is this?', back: 'Bu kim?' },
      { front: 'Whose?', back: 'Kimin?' },
      { front: 'Whose bag is this?', back: 'Bu kimin çantası?' },
    ]
  },
  '3-3': {
    type: 'flashcard',
    title: 'Can / Could / Would',
    cards: [
      { front: 'Can I help you?', back: 'Size yardımcı olabilir miyim?' },
      { front: 'Can I have water?', back: 'Su alabilir miyim?' },
      { front: 'Could you repeat?', back: 'Tekrar eder misiniz?' },
      { front: 'Could I have a blanket?', back: 'Bir battaniye alabilir miyim?' },
      { front: 'Would you like tea or coffee?', back: 'Çay mı kahve mi istersiniz?' },
      { front: 'Would you mind?', back: 'Sakıncası var mı?' },
      { front: 'May I see your passport?', back: 'Pasaportunuzu görebilir miyim?' },
      { front: 'May I help you?', back: 'Yardımcı olabilir miyim?' },
    ]
  },
  '3-4': {
    type: 'roleplay',
    title: 'Soru Pratiği',
    dialogue: [
      { speaker: 'A', text: 'Excuse me, where is the toilet?', translation: 'Affedersiniz, tuvalet nerede?' },
      { speaker: 'B', text: 'It is at the back of the aircraft.', translation: 'Uçağın arkasında.' },
      { speaker: 'A', text: 'How long is the flight?', translation: 'Uçuş ne kadar sürüyor?' },
      { speaker: 'B', text: 'About 3 hours.', translation: 'Yaklaşık 3 saat.' },
      { speaker: 'A', text: 'When do we arrive?', translation: 'Ne zaman varıyoruz?' },
      { speaker: 'B', text: 'We arrive at 5 PM local time.', translation: 'Yerel saatle 17:00\'de varıyoruz.' },
      { speaker: 'A', text: 'Can I have some water, please?', translation: 'Biraz su alabilir miyim, lütfen?' },
      { speaker: 'B', text: 'Of course. Here you are.', translation: 'Tabii ki. Buyrun.' },
    ]
  },
  '3-5': {
    type: 'quiz',
    title: 'Soru Quiz',
    questions: [
      { question: '"Nerede?" İngilizce nasıl denir?', options: ['What', 'When', 'Where', 'Why'], correct: 2 },
      { question: '"How much?" ne demek?', options: ['Nasıl?', 'Ne kadar?', 'Kaç tane?', 'Ne zaman?'], correct: 1 },
      { question: '"Can I help you?" ne demek?', options: ['Yardım eder misiniz?', 'Size yardım edebilir miyim?', 'Yardım!', 'Kim yardım eder?'], correct: 1 },
      { question: '"Would you like coffee?" ne demek?', options: ['Kahve nerede?', 'Kahve var mı?', 'Kahve ister misiniz?', 'Kahve lütfen'], correct: 2 },
      { question: '"Whose bag is this?" ne demek?', options: ['Bu çanta ne?', 'Çanta nerede?', 'Bu kimin çantası?', 'Çanta kaç para?'], correct: 2 },
      { question: '"Ne zaman?" İngilizce nasıl denir?', options: ['Where', 'What', 'When', 'Why'], correct: 2 },
    ]
  },

  // ÜNİTE 4: Zaman İfadeleri
  '4-1': {
    type: 'flashcard',
    title: 'Saat Kaç?',
    cards: [
      { front: 'What time is it?', back: 'Saat kaç?' },
      { front: 'It is 9 o\'clock.', back: 'Saat 9.' },
      { front: 'It is half past ten.', back: 'Saat 10 buçuk.' },
      { front: 'It is quarter past eleven.', back: 'Saat 11\'i çeyrek geçiyor.' },
      { front: 'It is quarter to twelve.', back: 'Saat 12\'ye çeyrek var.' },
      { front: 'It is 2:45 PM.', back: 'Öğleden sonra 2:45.' },
      { front: 'In the morning', back: 'Sabah' },
      { front: 'In the afternoon', back: 'Öğleden sonra' },
      { front: 'In the evening', back: 'Akşam' },
      { front: 'At night', back: 'Gece' },
      { front: 'At noon', back: 'Öğle vakti' },
      { front: 'At midnight', back: 'Gece yarısı' },
    ]
  },
  '4-2': {
    type: 'flashcard',
    title: 'Günler & Aylar',
    cards: [
      { front: 'Monday', back: 'Pazartesi' },
      { front: 'Tuesday', back: 'Salı' },
      { front: 'Wednesday', back: 'Çarşamba' },
      { front: 'Thursday', back: 'Perşembe' },
      { front: 'Friday', back: 'Cuma' },
      { front: 'Saturday', back: 'Cumartesi' },
      { front: 'Sunday', back: 'Pazar' },
      { front: 'January', back: 'Ocak' },
      { front: 'February', back: 'Şubat' },
      { front: 'March', back: 'Mart' },
      { front: 'April', back: 'Nisan' },
      { front: 'May', back: 'Mayıs' },
      { front: 'June', back: 'Haziran' },
      { front: 'July', back: 'Temmuz' },
      { front: 'August', back: 'Ağustos' },
      { front: 'September', back: 'Eylül' },
      { front: 'October', back: 'Ekim' },
      { front: 'November', back: 'Kasım' },
      { front: 'December', back: 'Aralık' },
    ]
  },
  '4-3': {
    type: 'flashcard',
    title: 'Bugün / Yarın / Dün',
    cards: [
      { front: 'Today', back: 'Bugün' },
      { front: 'Tomorrow', back: 'Yarın' },
      { front: 'Yesterday', back: 'Dün' },
      { front: 'This week', back: 'Bu hafta' },
      { front: 'Next week', back: 'Gelecek hafta' },
      { front: 'Last week', back: 'Geçen hafta' },
      { front: 'This month', back: 'Bu ay' },
      { front: 'Next month', back: 'Gelecek ay' },
      { front: 'Now', back: 'Şimdi' },
      { front: 'Later', back: 'Sonra' },
      { front: 'Soon', back: 'Yakında' },
      { front: 'Always', back: 'Her zaman' },
      { front: 'Sometimes', back: 'Bazen' },
      { front: 'Never', back: 'Asla' },
    ]
  },
  '4-4': {
    type: 'roleplay',
    title: 'Zaman Diyalogu',
    dialogue: [
      { speaker: 'A', text: 'Excuse me, what time is it?', translation: 'Affedersiniz, saat kaç?' },
      { speaker: 'B', text: 'It is half past two.', translation: 'Saat 2 buçuk.' },
      { speaker: 'A', text: 'What day is today?', translation: 'Bugün günlerden ne?' },
      { speaker: 'B', text: 'Today is Monday.', translation: 'Bugün Pazartesi.' },
      { speaker: 'A', text: 'When do we land?', translation: 'Ne zaman ineceğiz?' },
      { speaker: 'B', text: 'We land at 5:30 PM.', translation: 'Saat 17:30\'da ineceğiz.' },
      { speaker: 'A', text: 'How long until we arrive?', translation: 'Varmamıza ne kadar var?' },
      { speaker: 'B', text: 'About 2 hours.', translation: 'Yaklaşık 2 saat.' },
    ]
  },
  '4-5': {
    type: 'quiz',
    title: 'Zaman Quiz',
    questions: [
      { question: '"Wednesday" hangi gün?', options: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe'], correct: 2 },
      { question: '"Tomorrow" ne demek?', options: ['Dün', 'Bugün', 'Yarın', 'Şimdi'], correct: 2 },
      { question: '"It is half past three" saat kaç?', options: ['3:00', '3:15', '3:30', '3:45'], correct: 2 },
      { question: '"August" hangi ay?', options: ['Haziran', 'Temmuz', 'Ağustos', 'Eylül'], correct: 2 },
      { question: '"At midnight" ne demek?', options: ['Öğle vakti', 'Gece yarısı', 'Sabah', 'Akşam'], correct: 1 },
      { question: '"Next week" ne demek?', options: ['Bu hafta', 'Geçen hafta', 'Gelecek hafta', 'Her hafta'], correct: 2 },
    ]
  },

  // ÜNİTE 5: Yönler & Yerler
  '5-1': {
    type: 'flashcard',
    title: 'Sağ / Sol / Düz',
    cards: [
      { front: 'Right', back: 'Sağ' },
      { front: 'Left', back: 'Sol' },
      { front: 'Straight', back: 'Düz / Doğru' },
      { front: 'Turn right', back: 'Sağa dön' },
      { front: 'Turn left', back: 'Sola dön' },
      { front: 'Go straight', back: 'Düz git' },
      { front: 'On your right', back: 'Sağınızda' },
      { front: 'On your left', back: 'Solunuzda' },
      { front: 'This way', back: 'Bu taraftan' },
      { front: 'That way', back: 'O taraftan' },
      { front: 'Follow me', back: 'Beni takip edin' },
    ]
  },
  '5-2': {
    type: 'flashcard',
    title: 'Önde / Arkada / Yanda',
    cards: [
      { front: 'In front of', back: 'Önünde' },
      { front: 'Behind', back: 'Arkasında' },
      { front: 'Next to', back: 'Yanında' },
      { front: 'Between', back: 'Arasında' },
      { front: 'Near', back: 'Yakınında' },
      { front: 'Far', back: 'Uzakta' },
      { front: 'Inside', back: 'İçinde' },
      { front: 'Outside', back: 'Dışında' },
      { front: 'Above', back: 'Üstünde' },
      { front: 'Below', back: 'Altında' },
      { front: 'At the back', back: 'Arkada' },
      { front: 'At the front', back: 'Önde' },
    ]
  },
  '5-3': {
    type: 'flashcard',
    title: 'Nerede? Soruları',
    cards: [
      { front: 'Where is the toilet?', back: 'Tuvalet nerede?' },
      { front: 'Where is my seat?', back: 'Koltuğum nerede?' },
      { front: 'Where is the exit?', back: 'Çıkış nerede?' },
      { front: 'Where is the galley?', back: 'Mutfak nerede?' },
      { front: 'It is at the back.', back: 'Arkada.' },
      { front: 'It is at the front.', back: 'Önde.' },
      { front: 'It is on the right.', back: 'Sağda.' },
      { front: 'It is on the left.', back: 'Solda.' },
      { front: 'Row 15', back: '15. sıra' },
      { front: 'Seat A', back: 'A koltuğu' },
    ]
  },
  '5-4': {
    type: 'roleplay',
    title: 'Yön Tarifi Pratiği',
    dialogue: [
      { speaker: 'A', text: 'Excuse me, where is seat 22B?', translation: 'Affedersiniz, 22B koltuğu nerede?' },
      { speaker: 'B', text: 'Go straight and it is on your left.', translation: 'Düz gidin, solunuzda.' },
      { speaker: 'A', text: 'Where is the toilet?', translation: 'Tuvalet nerede?' },
      { speaker: 'B', text: 'It is at the back of the aircraft, on the right.', translation: 'Uçağın arkasında, sağda.' },
      { speaker: 'A', text: 'Is there a toilet at the front?', translation: 'Önde tuvalet var mı?' },
      { speaker: 'B', text: 'Yes, there is one near the cockpit.', translation: 'Evet, kokpit yakınında bir tane var.' },
      { speaker: 'A', text: 'Thank you very much.', translation: 'Çok teşekkür ederim.' },
      { speaker: 'B', text: 'You are welcome.', translation: 'Rica ederim.' },
    ]
  },
  '5-5': {
    type: 'quiz',
    title: 'Yön Quiz',
    questions: [
      { question: '"Turn left" ne demek?', options: ['Sağa dön', 'Sola dön', 'Düz git', 'Dur'], correct: 1 },
      { question: '"At the back" ne demek?', options: ['Önde', 'Yanda', 'Arkada', 'Üstte'], correct: 2 },
      { question: '"Next to" ne demek?', options: ['Altında', 'Üstünde', 'Yanında', 'İçinde'], correct: 2 },
      { question: '"Where is the exit?" ne demek?', options: ['Çıkış nerede?', 'Giriş nerede?', 'Tuvalet nerede?', 'Koltuk nerede?'], correct: 0 },
      { question: '"Go straight" ne demek?', options: ['Sağa git', 'Sola git', 'Düz git', 'Geri git'], correct: 2 },
      { question: '"Behind" ne demek?', options: ['Önünde', 'Arkasında', 'Yanında', 'İçinde'], correct: 1 },
    ]
  },

  // ÜNİTE 6: Yiyecek & İçecek
  '6-1': {
    type: 'flashcard',
    title: 'İçecekler',
    cards: [
      { front: 'Water', back: 'Su' },
      { front: 'Sparkling water', back: 'Maden suyu' },
      { front: 'Orange juice', back: 'Portakal suyu' },
      { front: 'Apple juice', back: 'Elma suyu' },
      { front: 'Tomato juice', back: 'Domates suyu' },
      { front: 'Coffee', back: 'Kahve' },
      { front: 'Tea', back: 'Çay' },
      { front: 'Milk', back: 'Süt' },
      { front: 'Coca-Cola', back: 'Kola' },
      { front: 'Beer', back: 'Bira' },
      { front: 'Wine', back: 'Şarap' },
      { front: 'Red wine', back: 'Kırmızı şarap' },
      { front: 'White wine', back: 'Beyaz şarap' },
      { front: 'Champagne', back: 'Şampanya' },
    ]
  },
  '6-2': {
    type: 'flashcard',
    title: 'Yiyecekler',
    cards: [
      { front: 'Chicken', back: 'Tavuk' },
      { front: 'Beef', back: 'Dana eti / Biftek' },
      { front: 'Fish', back: 'Balık' },
      { front: 'Pasta', back: 'Makarna' },
      { front: 'Rice', back: 'Pilav' },
      { front: 'Salad', back: 'Salata' },
      { front: 'Bread', back: 'Ekmek' },
      { front: 'Butter', back: 'Tereyağı' },
      { front: 'Cheese', back: 'Peynir' },
      { front: 'Vegetarian meal', back: 'Vejetaryen yemek' },
      { front: 'Dessert', back: 'Tatlı' },
      { front: 'Fruit', back: 'Meyve' },
      { front: 'Snack', back: 'Atıştırmalık' },
      { front: 'Peanuts', back: 'Fıstık' },
    ]
  },
  '6-3': {
    type: 'roleplay',
    title: 'Sipariş Verme',
    dialogue: [
      { speaker: 'A', text: 'Would you like something to drink?', translation: 'İçecek bir şey ister misiniz?' },
      { speaker: 'B', text: 'Yes, can I have orange juice, please?', translation: 'Evet, portakal suyu alabilir miyim?' },
      { speaker: 'A', text: 'Of course. With ice?', translation: 'Tabii ki. Buzlu mu?' },
      { speaker: 'B', text: 'No ice, thank you.', translation: 'Buzsuz, teşekkürler.' },
      { speaker: 'A', text: 'For lunch, we have chicken or fish.', translation: 'Öğle yemeği için tavuk veya balık var.' },
      { speaker: 'B', text: 'I\'ll have the chicken, please.', translation: 'Tavuk alayım, lütfen.' },
      { speaker: 'A', text: 'Would you like some bread?', translation: 'Biraz ekmek ister misiniz?' },
      { speaker: 'B', text: 'Yes, please.', translation: 'Evet, lütfen.' },
    ]
  },
  '6-4': {
    type: 'voice',
    title: 'Tercih Sorma',
    phrases: [
      { text: 'Would you like tea or coffee?', translation: 'Çay mı kahve mi istersiniz?' },
      { text: 'Would you like chicken or beef?', translation: 'Tavuk mu dana eti mi istersiniz?' },
      { text: 'With milk or without?', translation: 'Sütlü mü sütsüz mü?' },
      { text: 'Still or sparkling water?', translation: 'Sade mi maden suyu mu?' },
      { text: 'Any allergies I should know about?', translation: 'Bilmem gereken bir alerji var mı?' },
      { text: 'Can I get you anything else?', translation: 'Başka bir şey alabilir miyim?' },
    ]
  },
  '6-5': {
    type: 'quiz',
    title: 'Yemek Quiz',
    questions: [
      { question: '"Chicken" ne demek?', options: ['Balık', 'Tavuk', 'Et', 'Sebze'], correct: 1 },
      { question: '"Would you like tea or coffee?" ne demek?', options: ['Çay kahve var mı?', 'Çay mı kahve mi?', 'Çay ve kahve', 'Çay kahve yok'], correct: 1 },
      { question: '"Sparkling water" ne demek?', options: ['Soğuk su', 'Sıcak su', 'Maden suyu', 'Kaynak suyu'], correct: 2 },
      { question: '"Vegetarian meal" ne demek?', options: ['Et yemeği', 'Balık yemeği', 'Vejetaryen yemek', 'Tatlı'], correct: 2 },
      { question: '"With ice" ne demek?', options: ['Buzsuz', 'Buzlu', 'Soğuk', 'Sıcak'], correct: 1 },
      { question: '"Bread" ne demek?', options: ['Pilav', 'Makarna', 'Ekmek', 'Salata'], correct: 2 },
    ]
  },

  // ÜNİTE 7: Günlük Diyaloglar
  '7-1': {
    type: 'flashcard',
    title: 'Teşekkür & Rica',
    cards: [
      { front: 'Thank you', back: 'Teşekkürler' },
      { front: 'Thank you very much', back: 'Çok teşekkür ederim' },
      { front: 'Thanks a lot', back: 'Çok sağol' },
      { front: 'You are welcome', back: 'Rica ederim' },
      { front: 'No problem', back: 'Sorun değil' },
      { front: 'My pleasure', back: 'Memnuniyetle' },
      { front: 'Please', back: 'Lütfen' },
      { front: 'Of course', back: 'Tabii ki' },
      { front: 'Certainly', back: 'Kesinlikle / Elbette' },
      { front: 'Sure', back: 'Tabi / Elbette' },
      { front: 'I appreciate it', back: 'Minnettarım' },
    ]
  },
  '7-2': {
    type: 'flashcard',
    title: 'Özür Dileme',
    cards: [
      { front: 'Sorry', back: 'Özür dilerim' },
      { front: 'I am sorry', back: 'Özür dilerim' },
      { front: 'Excuse me', back: 'Affedersiniz / Pardon' },
      { front: 'Pardon me', back: 'Pardon' },
      { front: 'I apologize', back: 'Özür dilerim' },
      { front: 'That\'s okay', back: 'Sorun değil' },
      { front: 'No worries', back: 'Merak etmeyin' },
      { front: 'It\'s alright', back: 'Önemli değil' },
      { front: 'Don\'t worry about it', back: 'Takma kafana' },
      { front: 'I\'m terribly sorry', back: 'Çok özür dilerim' },
    ]
  },
  '7-3': {
    type: 'roleplay',
    title: 'Yardım İsteme',
    dialogue: [
      { speaker: 'A', text: 'Excuse me, can you help me?', translation: 'Affedersiniz, bana yardım edebilir misiniz?' },
      { speaker: 'B', text: 'Of course, how can I help you?', translation: 'Tabii ki, nasıl yardımcı olabilirim?' },
      { speaker: 'A', text: 'I can\'t find my boarding pass.', translation: 'Biniş kartımı bulamıyorum.' },
      { speaker: 'B', text: 'Don\'t worry, let me help you look for it.', translation: 'Merak etmeyin, aramanıza yardım edeyim.' },
      { speaker: 'A', text: 'Thank you so much.', translation: 'Çok teşekkür ederim.' },
      { speaker: 'B', text: 'Is this it?', translation: 'Bu mu?' },
      { speaker: 'A', text: 'Yes! Thank you very much!', translation: 'Evet! Çok teşekkürler!' },
      { speaker: 'B', text: 'You\'re welcome. Have a nice flight.', translation: 'Rica ederim. İyi uçuşlar.' },
    ]
  },
  '7-4': {
    type: 'roleplay',
    title: 'Kibarca Reddetme',
    dialogue: [
      { speaker: 'A', text: 'Would you like more coffee?', translation: 'Daha kahve ister misiniz?' },
      { speaker: 'B', text: 'No, thank you. I\'m fine.', translation: 'Hayır, teşekkürler. İyiyim.' },
      { speaker: 'A', text: 'Would you like a newspaper?', translation: 'Gazete ister misiniz?' },
      { speaker: 'B', text: 'No, thanks. I have a book.', translation: 'Hayır, teşekkürler. Kitabım var.' },
      { speaker: 'A', text: 'Can I get you anything else?', translation: 'Başka bir şey getirebilir miyim?' },
      { speaker: 'B', text: 'I\'m good for now, thank you.', translation: 'Şimdilik iyiyim, teşekkürler.' },
      { speaker: 'A', text: 'Just let me know if you need anything.', translation: 'Bir şeye ihtiyacınız olursa söyleyin.' },
      { speaker: 'B', text: 'I will. Thank you.', translation: 'Söylerim. Teşekkürler.' },
    ]
  },
  '7-5': {
    type: 'quiz',
    title: 'Diyalog Quiz',
    questions: [
      { question: '"You\'re welcome" ne demek?', options: ['Hoş geldiniz', 'Rica ederim', 'Teşekkürler', 'Merhaba'], correct: 1 },
      { question: '"Excuse me" ne demek?', options: ['Teşekkürler', 'Özür dilerim/Pardon', 'Merhaba', 'Güle güle'], correct: 1 },
      { question: '"No problem" ne demek?', options: ['Sorun var', 'Sorun değil', 'Ne sorunu', 'Büyük sorun'], correct: 1 },
      { question: '"I\'m good for now" ne demek?', options: ['İyiyim şimdi', 'Şimdilik iyiyim/yeterli', 'İyi değilim', 'Şimdi git'], correct: 1 },
      { question: '"My pleasure" ne demek?', options: ['Zevkim', 'Memnuniyetle', 'Eğlenceli', 'Hoş'], correct: 1 },
      { question: '"Don\'t worry" ne demek?', options: ['Merak et', 'Endişelen', 'Merak etme', 'Kork'], correct: 2 },
    ]
  },

  // ÜNİTE 8: Temel İngilizce Sınavı
  '8-1': {
    type: 'flashcard',
    title: 'Kelime Tekrarı',
    cards: [
      { front: 'Boarding pass', back: 'Biniş kartı' },
      { front: 'Passport', back: 'Pasaport' },
      { front: 'Luggage', back: 'Bagaj' },
      { front: 'Carry-on bag', back: 'Kabin çantası' },
      { front: 'Gate', back: 'Kapı (çıkış kapısı)' },
      { front: 'Departure', back: 'Kalkış' },
      { front: 'Arrival', back: 'Varış' },
      { front: 'Delay', back: 'Gecikme' },
      { front: 'Flight', back: 'Uçuş' },
      { front: 'Passenger', back: 'Yolcu' },
      { front: 'Seat belt', back: 'Emniyet kemeri' },
      { front: 'Emergency exit', back: 'Acil çıkış' },
    ]
  },
  '8-2': {
    type: 'voice',
    title: 'Dinleme Testi',
    phrases: [
      { text: 'Ladies and gentlemen, welcome aboard.', translation: 'Bayanlar ve baylar, uçağımıza hoş geldiniz.' },
      { text: 'Please fasten your seat belts.', translation: 'Lütfen emniyet kemerlerinizi bağlayın.' },
      { text: 'The flight time today is approximately 3 hours.', translation: 'Bugünkü uçuş süresi yaklaşık 3 saattir.' },
      { text: 'We will be serving refreshments shortly.', translation: 'Kısa süre sonra ikram servisimiz başlayacak.' },
      { text: 'If you need any assistance, please call a cabin crew member.', translation: 'Yardıma ihtiyacınız olursa, lütfen kabin ekibini çağırın.' },
      { text: 'Thank you for flying with us today.', translation: 'Bugün bizimle uçtuğunuz için teşekkür ederiz.' },
    ]
  },
  '8-3': {
    type: 'roleplay',
    title: 'Konuşma Testi',
    dialogue: [
      { speaker: 'A', text: 'Good morning! May I see your boarding pass?', translation: 'Günaydın! Biniş kartınızı görebilir miyim?' },
      { speaker: 'B', text: 'Of course, here it is.', translation: 'Tabii ki, buyrun.' },
      { speaker: 'A', text: 'Your seat is 14A, by the window.', translation: 'Koltuğunuz 14A, pencere kenarı.' },
      { speaker: 'B', text: 'Where is row 14?', translation: 'Sıra 14 nerede?' },
      { speaker: 'A', text: 'Go straight and it\'s on your left.', translation: 'Düz gidin, solunuzda.' },
      { speaker: 'B', text: 'Thank you. Where can I put my bag?', translation: 'Teşekkürler. Çantamı nereye koyabilirim?' },
      { speaker: 'A', text: 'In the overhead compartment above your seat.', translation: 'Koltuğunuzun üstündeki bagaj gözüne.' },
      { speaker: 'B', text: 'Great, thanks!', translation: 'Harika, teşekkürler!' },
    ]
  },
  '8-4': {
    type: 'quiz',
    title: 'Yazılı Test',
    questions: [
      { question: '"Please fasten your seat belt" ne demek?', options: ['Kemeri çıkarın', 'Emniyet kemerini bağlayın', 'Ayağa kalkın', 'Oturun'], correct: 1 },
      { question: 'Uçakta "aisle seat" ne demek?', options: ['Pencere koltuğu', 'Orta koltuk', 'Koridor koltuğu', 'Ön koltuk'], correct: 2 },
      { question: '"Overhead compartment" nedir?', options: ['Alt bölme', 'Üst bagaj gözü', 'Koltuk cebi', 'Tuvalet'], correct: 1 },
      { question: '"We will be landing shortly" ne demek?', options: ['Kalkıyoruz', 'Yakında ineceğiz', 'Türbülans var', 'Gecikme var'], correct: 1 },
      { question: '"May I help you?" ne demek?', options: ['Yardım eder misiniz?', 'Yardım edemem', 'Size yardımcı olabilir miyim?', 'Yardım gerekli'], correct: 2 },
      { question: '"Cabin crew" ne demek?', options: ['Pilot', 'Yolcu', 'Kabin ekibi', 'Kaptan'], correct: 2 },
      { question: '"Life jacket" ne demek?', options: ['Ceket', 'Can yeleği', 'Battaniye', 'Yastık'], correct: 1 },
      { question: '"Emergency exit" ne demek?', options: ['Giriş kapısı', 'Normal çıkış', 'Acil çıkış', 'Pilot kabini'], correct: 2 },
    ]
  },
  '8-5': {
    type: 'exam',
    title: 'BÖLÜM 1 FİNAL',
    description: 'Temel İngilizce bölümünün final sınavı. Tüm konulardan sorular içerir.',
    totalQuestions: 20,
    passingScore: 70
  }
};

// İçerik getirme fonksiyonu
export const getLessonContent = (unitId, lessonId) => {
  const key = `${unitId}-${lessonId}`;
  return LESSON_CONTENTS[key] || null;
};

// Ünite içerik kontrolü
export const hasLessonContent = (unitId, lessonId) => {
  const key = `${unitId}-${lessonId}`;
  return !!LESSON_CONTENTS[key];
};

export default LESSON_CONTENTS;
